import { pdfjs } from 'react-pdf';
/// <reference types="vite/client" />
let pdfWorkerUrl: string | undefined;
try {
  pdfWorkerUrl = require('pdfjs-dist/build/pdf.worker.min.js');
  if (typeof pdfWorkerUrl !== 'string') {
    pdfWorkerUrl = undefined;
  }
} catch (_) {
  pdfWorkerUrl = undefined;
}

declare global {
  interface PromiseConstructor {
    allSettled<T>(
      values: Iterable<T | PromiseLike<T>>,
    ): Promise<Array<{ status: 'fulfilled'; value: T } | { status: 'rejected'; reason: unknown }>>;
  }
}

if (typeof Promise.allSettled !== 'function') {
  Object.defineProperty(Promise, 'allSettled', {
    configurable: true,
    writable: true,
    value: function <T>(values: Iterable<T | PromiseLike<T>>) {
      const arr = Array.from(values);
      return Promise.all(
        arr.map((item) =>
          Promise.resolve(item)
            .then((value) => ({ status: 'fulfilled' as const, value }))
            .catch((reason) => ({ status: 'rejected' as const, reason })),
        ),
      );
    },
  });
}

// 🔧 CONFIGURACIÓN DEL WORKER PARA REACT-PDF 8.0.2
// Esta configuración debe ejecutarse antes de usar cualquier componente PDF
export function configurePDFWorker(): void {
  const cdnVersion = '3.11.174';
  const cdn = `https://unpkg.com/pdfjs-dist@${cdnVersion}/build/pdf.worker.min.js`;
  let chosen = cdn;
  if (pdfWorkerUrl && typeof pdfWorkerUrl === 'string') {
    chosen = pdfWorkerUrl;
  }
  pdfjs.GlobalWorkerOptions.workerSrc = chosen;
  // tslint:disable-next-line:no-console
  console.log('✅ PDF Worker configurado:', chosen);
}

// Configuración alternativa local si UNPKG falla
export function configurePDFWorkerLocal(): void {
  try {
    pdfjs.GlobalWorkerOptions.workerSrc = '/node_modules/pdfjs-dist/build/pdf.worker.min.js';
    console.log('✅ PDF Worker configurado (local):', pdfjs.GlobalWorkerOptions.workerSrc);
  } catch (error) {
    console.error('❌ Error configurando worker local:', error);
    configurePDFWorker();
  }
}

// Auto-configuración al importar
configurePDFWorker();
